<template>
  <select
    class="cusc-select"
    v-bind="$attrs"
    name="certificationId"
    :value="selectedId"
    @change="emit('update:certificationId', Number(($event.target as HTMLSelectElement).value))"
  >
    <option v-for="option in options" :value="option?.id" :key="option?.id">
      Cert. #{{ option.sequenceNumber }} - {{ option?.amount }} -
      {{ option?.status }}
    </option>
  </select>
</template>

<script setup lang="ts">
import type { CertificationDropdownOption } from "@/models/certificationService";

const props = defineProps<{
  options: CertificationDropdownOption[];
  selectedId: number;
}>();

const emit = defineEmits<{
  (e: "update:certificationId", value: number): void;
}>();
</script>

<style scoped>
select {
  border-radius: 4px;
  border: 1px solid #ced1d9;
  background: #fafafa;
  height: 40px;
  padding: 0 16px;
  width: 100%;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  --dropdownFontSize: 14px;
  --dropdownBgSize: 14px;
}

.cusc-select {
  /* Step 1: Remove the default browser arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Step 2: Styling the select box text and container */
  width: 100%;
  padding: 10px 40px 10px 12px; /* Extra right padding ensures text doesn't overlap the arrow */
  font-size: var(--dropdownFontSize);
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fafafa;

  /* Step 3: Add your custom SVG arrow via URL data */
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="none"><g clip-path="url(%23clip0_104_45)"><path d="M3 2L8 7L13 2" stroke="%23808080" stroke-width="2" stroke-linecap="round"/></g><defs><clipPath id="clip0_104_45"><rect width="16" height="8" fill="white"/></clipPath></defs></svg>');
  background-repeat: no-repeat;
  background-position: right 12px center; /* Aligns the arrow 12px from the right edge */
  background-size: var(--dropdownBgSize); /* Adjust size of your arrow */
  cursor: pointer;
}

/* Focus state styling */
select.cusc-select:focus {
  outline: 2px solid #eee;
  border-color: transparent;
}

/* allow text to grow with height and wrap when it does not fix single line */
.cusc-select {
  overflow: hidden;
  white-space: normal;
  height: auto;
}
</style>
